<template>
  <section>
    <div v-if="!isSentForm && !isSignaturePage" class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
            v-for="tab in tabs"
            :key="tab.id"
            class="router-link"
            @click="updateTab(tab)"
            :class="{ active: selectedTab.name === tab.name }"
        >{{tab.name}}
        </li>
      </ul>
    </div>
    <form v-if="!isSentForm && !isSignaturePage" @submit.prevent="sendForm" class="container">



      <div class="coop-type" v-if="selectedTab.key==='coop'">
        <h4 class="title-list">1. סוג שיתוף הפעולה וחלוקת עמלה:</h4>
        <label >
        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value="cooperate" v-model="coopType">
          קופה משותפת
          <span v-if="coopType==='cooperate'" class="tip">מחברים יחד את עמלת המוכר, ואת עמלת הקונה, וכל מתווך מקבל חצי.</span>
        </label>
        <label >
        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" value="single" v-model="coopType">
          כל אחד מהלקוח שלו
          <span v-if="coopType==='single'" class="tip inline">כל מתווך גובה מהלקוח שלו, את מה שסיכם עם הלקוח שלו.</span>
        </label>
        <label >
        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3" value="b2b" v-model="coopType">
          מתווך הקונה מעביר למתווך המוכר
          <div v-if="coopType==='b2b'" class="b2b-options">
            <input placeholder="עמלה" class="my-input ml-3" type="text" v-model="b2b.value">
          <select class="my-input " v-model="b2b.type">
            <option value="%">אחוז(%)</option>
            <option value="₪">שקלים חדשים (₪)</option>
            <option value="חודשי שכירות">חודשי שכירות</option>
          </select>

          </div>
        </label>
      </div>


<!--      v-if="selectedTab.key!=='coop'"-->
  <div  class="transaction-type">
    <h4 class="title-list">1. סוג העסקה + עמלת התיווך:</h4>
<div class="rent-section">
    <label class="checkbox-type" for="rent">
    <input id="rent"  type="checkbox" class="form-check-input " v-model="rent.isRent">
      השכרה
    </label>
  <input type="number" min="1" class="my-input " v-if="rent.isRent" v-model="rent.commision" placeholder="עמלה">
    <select name="" v-model="rent.type" v-if="rent.isRent"  class="my-input" >
      <option value="%">חודשי שכירות</option>
      <option value="₪">₪</option>
    </select>
</div>

<div class="sell-section">
    <label  for="sell" class="checkbox-type">
    <input type="checkbox" class="form-check-input" v-model="sell.isSelling">
      מכירה
    </label>
    <input id="sell" class="my-input" v-if="sell.isSelling"  type="number" placeholder="עמלה" min="1" v-model="sell.commision">
    <select  class="my-input" v-if="sell.isSelling" v-model="sell.type" >
      <option value="%">אחוז</option>
      <option value="₪">₪</option>
    </select>
  </div>
  </div>
<!--      <div v-if="selectedTab.key==='coop'" class="transaction-type">-->
<!--        <h4 class="title-list">2.סוג העסקה</h4>-->
<!--        <div class="rent-section">-->
<!--        <label class="checkbox-type" for="rent2">-->
<!--          <input id="rent2"  type="checkbox" class="form-check-input " v-model="rent.isRent">-->
<!--          השכרה-->
<!--        </label>-->
<!--        </div>-->
<!--        <div class="sell-section">-->
<!--        <label class="checkbox-type">-->
<!--          <input type="checkbox" class="form-check-input" v-model="sell.isSelling">-->
<!--          מכירה-->
<!--        </label>-->
<!--        </div>-->
<!--      </div>-->

    <hr class="divider">
  <div class="property-owner">
    <h4 v-if="selectedTab.key==='owner'" class="title-list">2.פרטי בעל הנכס להחתמה:</h4>
    <h4 v-if="selectedTab.key==='interested'" class="title-list">2.פרטי מתעניין להחתמה:</h4>
    <h4 v-if="selectedTab.key==='coop'" class="title-list">3.בחירת מתווכים לשת"פ:</h4>
    <input type="text" placeholder="שם לקוח להחתמה" v-model="owner.name" class="form-control">
    <input type="tel" placeholder="מספר טלפון " v-model="owner.phone" class="form-control">
  </div>
    <hr class="divider">
  <div class="estates-info">
    <h4 class="title-list">3.פרטי הנכסים:</h4>
    <span class="tip">
      טיפ:ניתן לבחור מספר נכסים
    </span>
    <input placeholder="הקלד כתובת הנכס" type="text" v-model="owner.address" class="form-control">
  </div>
    <hr class="divider">
  <div class="time" v-if="selectedTab.key==='owner'">
    <h4 class="title-list">4.תקופת בלעדיות(הפקת הסכם בלעדיות):</h4>
    <span class="tip">
      <p>המערכת תשלח לבעל הנכס את הסכם הבלעדיות במסמך נפרד (כנדרש בחוק),
כך שיהיה עליו לחתום על 2 מסמכים. גם על הסכם התיווך, וגם על הסכם הבלעדיות.</p>
    </span>
    <select name="" v-model="exclusivity.isExclus" class="form-control exclus mb-15">
      <option :value=false>ללא בלעדיות</option>
      <option value="6">בלעדיות 6 חודשים</option>
      <option value="5">בלעדיות 5 חודשים</option>
      <option value="4">בלעדיות 4 חודשים</option>
      <option value="3">בלעדיות 3 חודשים</option>
      <option value="2">בלעדיות 2 חודשים</option>
      <option value="1">בלעדיות 1 חודש</option>
    </select>
    <label v-if="exclusivity.isExclus" for="date-from" class="date date-from">
      מתאריך
    <input id="date-from" type="date" v-model="exclusivity.from" class="form-control ">
    </label>
    <label v-if="exclusivity.isExclus"  for="date-to" class="date date-to">
      עד תאריך
    <input id="date-to" type="date" class="form-control" v-model="exclusivity.to">
    </label>
  </div>
    <hr class="divider" v-if="selectedTab.key==='owner'">
  <div class="first-page sum">
    <label for="comments" class="comments">
      הערות(לא חובה):
      <input id="comments" type="text" v-model="options.comments" class="form-control  " placeholder="ניתן להוסיף כאן הערות">
    </label>

    <label for="sendSms" class="block">
      <input id="sendSms" type="checkbox" v-model="options.shouldSendSms">
שלח טופס בSMS בסוף התהליך.    </label>
  </div>
    <div class="btns-container">
    <button type="button" disabled class="btn btn-primary">  <i class="far fa-eye ml-3"></i>תצוגה

    </button>
    <button type="submit" class="btn btn-success rtl"> הפקת הסכם <i class="fas fa-check"></i>
    </button>
    </div>
  </form>
    <agreement-preview @download="download" @toSignature="toSignature" @onShowForm="showForm"
                       v-if="isFormCompleted && isSentForm && !isSignaturePage && !agreementLink"
                       :rent="rent" :sell="sell" :owner="owner" :options="options"
                       :isPdf="isPdf" :isPreview="isPreview" :exclusivity="exclusivity" :signatureBase="signatureBase"
                       :documentType="selectedTab.key" :coopType="coopType" :b2b="b2b" />
    <signature @showAgreement="showAgreement" @createPdf="createPdf" v-if="isSignaturePage"/>
    <agreement-created @createAnotherAgreement="showForm" :agreementLink="agreementLink" v-if="agreementLink" :ownerPhone="owner.phone"/>
  </section>

</template>

<script>
import AgreementPreview from "../cmps/agreement-preview";
import Signature from "../cmps/signature"
import AgreementCreated from "../cmps/agreement-created"
import apiClientCreator from "../../../../helpers/api/request";

export default {
  name: "DigitalSignatureForm",
  components: { Signature,  AgreementPreview,AgreementCreated},
  data(){
    return{
      rent:{
        isRent:false,
        commision:"1",
        type:"₪"
      },
      sell:{
        isSelling:false,
        commision:"1",
        type:"₪"
      },
      owner:{
        name:"שמעון",
      address:"אלנבי 25 תל אביב",
        phone:'0544777604'
    },
      exclusivity:{
        isExclus:false,
        from:null,
        to:null
      },
      options:{
        comments:'',
        shouldSendSms:true,
      },
        isSentForm:false,
      isSignaturePage:false,
      signatureBase:null,
      isPreview:false,
      isPdf:false,
      agreementLink:null,
      tabs:[{id:1,name:"החתמת בעל נכס",key:"owner"},{id:2,name:"החתמת מתעניין" , key:"interested"},{id:3,name: "שת\"פ מתווכים",key: "coop"}],
      selectedTab:{id:1,name:"החתמת בעל נכס",key:"owner"},
      coopType:'cooperate',
      b2b:{
        value:'',
        type:'%'
      },
    }
  },
  computed:{
    isFormCompleted(){
      const {rent,sell,owner,options,exclusivity} = this
      let res=false;
      if(rent.isRent && rent.type && rent.commision &&  owner.name && owner.address ) res= true;
      else if (sell.isSelling && sell.type && sell.commision && owner.name && owner.address ) res= true;
      if(exclusivity.isExclus) {
        if(exclusivity.to && exclusivity.from) res=true
        else res=false
      }
      return res
    }
  },
  created() {
  },
  methods:{
    async download(){
      const {rent,sell,owner,exclusivity,options,signatureBase} = this
      const formData = {sell,owner,exclusivity,options,signatureBase,rent};
      this.isPdf=true
      this.isPreview=false
      let data;
      setTimeout(async ()=>{
        const documentTemplate = document.querySelector(".big-container").innerHTML
        const response = await apiClientCreator('projects/forms/real_estate/form1').post("", { documentTemplate} )
        data = response.data
        if(this.options.shouldSendSms){
        const sendSMSReq = apiClientCreator(`client/sms/sendSpecificSms`);
        const message = `נוצר טופס דיגיטלי חדש! לחץ על הקישור כדי לצפות
      ${data}`
        await sendSMSReq.post("",{message, phoneNumber:this.owner.phone})
        } // Will send sms with the
        this.agreementLink=data
      },100)
      setTimeout( ()=>{
        window.open(data,'_blank')

      },3000)

    },
    sendForm(){
      if(this.isFormCompleted){
        this.isSentForm=true;
        this.isPreview=true
      }
    },
    toSignature(){
        this.isSignaturePage=true
      },
    showForm(){
      this.isSignaturePage=false
      this.isSentForm=false;
      this.signatureBase=null
      if(this.agreementLink){
      this.isPdf=false
        this.resetFormData()
        this.agreementLink=null
      }
    },
    resetFormData(){
      this.rent = {
        isRent:false,
            commision:"1",
            type:"₪"
      },
      this.sell={
        isSelling:false,
            commision:"1",
            type:"₪"
      },
      this.owner={
        name:"",
            address:""
      },
      this.exclusivity={
        isExclus:false,
            from:null,
            to:null
      },
      this.options={
        comments:'',
            shouldSendSms:true,
      }
    },
    showAgreement(){
      this.isSignaturePage=false
    },
    createPdf(data){
      this.signatureBase=data
      this.isSignaturePage=false
      this.isSentForm=true
    },
    updateTab(tab){
      this.selectedTab=  tab ;
    },
  },
  watch:{
    coopType:function(){
    },
    selectedTab:function(){
    }
  }

};
</script>

<style scoped>
.container{
  direction: rtl;
  font-family: "Helvetica", sans-serif;
  width: 80%;
  background-color: #f4f4f4;
  border-radius: 10px;
  margin-top: 10px;
}
.title-list{
  color: #2d7cb5;
}
.rent-section,.sell-section{
  display: flex;
  margin-bottom: 10px;
  width: 320px;
  justify-content: space-between;
}
.my-input {
  background: lightblue;
  border: 0;
  /*margin-right: 5px;*/
  /*margin-bottom: 10px;*/
  width: 120px;
  border-radius: 6px;
  padding:5px 10px;
}
.checkbox-type{
  min-width: 65px;
}
input{
  margin: 0;
}
.tip{
  display: block;
  background: lightblue;
  border-radius: 5px;
  padding: 3px;
  margin: 5px;
  font-size: 12px;
  width: fit-content;

}
.divider{
  background: lightgrey;
  height: 1px;
}
.btns-container{
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.btn{
  margin-top: 20px;
  width: 120px;
  font-size: 1.6rem;
  text-align: center;
}
.exclus{
  width: 100%;
}
.mb-15{
  margin-bottom: 15px;
}
.block{
  display: block;
}
.ml-3{
  margin-left: 6px;
}

.comments{
  width: 100%;
}
.main-nav{
  font-family: Tahoma;
  direction: rtl;
}
label{
  display: block;
}
.style-nav .router-link {
  max-width: 150px;
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}
.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}
.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}
.style-nav.style1{
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
}
.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}
.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

@media (max-width: 550px){
  .container{
    width: 95% ;
  }
  .rent-section,.sell-section,.date{
    width: 100%

  }
  .my-input{
    width: 33%;
  }
  .exclus{
    width: 100%;
  }
  .date{
    width: 100%;
  }
}
</style>